import * as Yup from 'yup'

export const createCourseSchema = Yup.object().shape({
  title: Yup.object().shape({
    uz: Yup.string().required('Kurs nomi (uz) majburiy'),
    ru: Yup.string().required('Kurs nomi (ru) majburiy'),
    en: Yup.string().required('Kurs nomi (en) majburiy'),
  }),
  sub_title: Yup.object().shape({
    uz: Yup.string().required('Kurs haqida qisqacha (uz) majburiy'),
    ru: Yup.string().required('Kurs haqida qisqacha (ru) majburiy'),
    en: Yup.string().required('Kurs haqida qisqacha (en) majburiy'),
  }),
  description: Yup.object().shape({
    uz: Yup.string().required('Tavsif (uz) majburiy'),
    ru: Yup.string().required('Tavsif (ru) majburiy'),
    en: Yup.string().required('Tavsif (en) majburiy'),
  }),
  image: Yup.mixed().required('Rasm majburiy'),
  first_color: Yup.string().required('Rang majburiy'),
  second_color: Yup.string().required('Rang majburiy'),
})